/* unplugin-vue-components disabled */import { render } from "./user-topics.vue?vue&type=template&id=ae8fbd36&scoped=true"
import script from "./user-topics.vue?vue&type=script&lang=js"
export * from "./user-topics.vue?vue&type=script&lang=js"

import "./user-topics.vue?vue&type=style&index=0&id=ae8fbd36&lang=stylus&scoped=true"

import exportComponent from "/home/runner/work/buzz-front/buzz-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ae8fbd36"],['__file',"src/pages/tenants/user/topics/user-topics.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "ae8fbd36"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('ae8fbd36', __exports__)) {
    api.reload('ae8fbd36', __exports__)
  }
  
  module.hot.accept("./user-topics.vue?vue&type=template&id=ae8fbd36&scoped=true", () => {
    api.rerender('ae8fbd36', render)
  })

}


export default __exports__